import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import classNames from 'classnames'
import {XIcon} from '@src/assets/icons'
import {trans} from '@utils'
//************************************//
const FilterSearchControls = (props) => {
  const {data, showClearAll, onClear, onClearAll} = props
  //************************************//
  const _renderFilterSearchControl = (item) => {
    if (!item.isRendered) return
    const {key, title, hidden, forced} = item
    return title && (
      <div className={classNames('filter-search-control btn-group mr-1 mb-1', { hidden })} key={key}>
        <button type="button" className="filter-search-control-label btn btn-sm text-dark text-truncate" style={{ maxWidth: '270px' }}>
          {title}
        </button>
        {!forced && (
          <button type="button" className="filter-search-control-clear btn btn-sm dropdown-toggle-split" onClick={() => onClear(key)}>
            <FontAwesomeIcon icon={XIcon} className="text-secondary text-lighten-1"/>
          </button>
        )}
      </div>
    )
  }
  //************************************//
  return (
    <div className="filter-search-controls">
      {_.map(data, _renderFilterSearchControl)}
      {showClearAll &&
        <button className="filter-search-control-clear-all btn btn-sm btn-none p-0 mb-1" onClick={onClearAll}>
          <span className='ml-25'>{trans('gen.datatable.clearAll')}</span>
        </button>}
    </div>
  )
}
export default FilterSearchControls